import {StempelModel} from "../../../core/sharedmodels/stempel/stempelModel";
import {
    UserProfileAvatar,
    UserProfileAvatarSizeEnum,
    UserProfileLayoutEnum
} from "../../../core/components/userProfileAvatar/userProfileAvatar";
import {UserProfileAvatarModel} from "../../../core/components/userProfileAvatar/userProfileAvatarModel";
import React from "react";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {ReactTooltip} from "../../../core/components/tooltips/ReactTooltip";
import classNames from "classnames";

type BesvaretAf = {
    stempel: StempelModel;
    includeMargin?: boolean;
}
export const BesvaretAf = ({stempel, includeMargin = false}: BesvaretAf) => {
    const tooltipId = `tooltip-${stempel.id}`;
    return (
        <>
            <div id={tooltipId} className={classNames("flex-container-column border padding-xs border-radius-5 flex-align-r small", includeMargin && "margin-bottom-s")} style={{cursor:"default"}}>
                <UserProfileAvatar size={UserProfileAvatarSizeEnum.extraExstraSmall}
                                   userProfileAvatarModel={new UserProfileAvatarModel("", stempel.navn, stempel?.initialer, false)}
                                   userProfileLayoutEnum={UserProfileLayoutEnum.AsTextOnRightSide}
                                   subtle
                />
            </div>
            <ReactTooltip selectId={tooltipId} place="top">
                <div className={"flex-container-column "}>
                        <div className={"flex-start"}>{`${stempel.navn}`}</div>
                        <div className={"flex-start"}>{`${stempel.rolleTitel}`}</div>
                        <div className={"flex-start"}>{`${Localizer.dato()}: ${stempel.dato.dateWithoutTimeFormat(true)}`}</div>
                </div>
            </ReactTooltip>
        </>
    );
}
